module.exports = __webpack_public_path__ + "media/images/top/reserved_pending-0f982233ee17528d7c52eb81c9701d5e.png";